// extracted by mini-css-extract-plugin
module.exports = {"card":"CardLayout_card__3y7j6","columns":"CardLayout_columns__nHH9u","columnsDual":"CardLayout_columnsDual__N07sP","column":"CardLayout_column__f0Cem"};